import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { BadgeKiller } from '@/components/BadgeKiller';
import { AdminProvider } from '@/contexts/AdminContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { HomePage } from '@/pages/HomePage';
import { ServicesPage } from '@/pages/ServicesPage';
import { WorkPage } from '@/pages/WorkPage';
import { PricingPage } from '@/pages/PricingPage';
import { AboutPage } from '@/pages/AboutPage';
import { ContactPage } from '@/pages/ContactPage';
import { AdminLeadsPage } from '@/pages/AdminLeadsPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { TermsPage } from '@/pages/TermsPage';
import { AdminLoginPage } from '@/pages/admin/AdminLoginPage';
import { AdminDashboardPage } from '@/pages/admin/AdminDashboardPage';
import { AdminServicesPage } from '@/pages/admin/AdminServicesPage';
import { AdminProjectsPage } from '@/pages/admin/AdminProjectsPage';
import { AdminTestimonialsPage } from '@/pages/admin/AdminTestimonialsPage';
import { AdminFAQsPage } from '@/pages/admin/AdminFAQsPage';
import { AdminPricingPage } from '@/pages/admin/AdminPricingPage';
import { AdminAboutPage } from '@/pages/admin/AdminAboutPage';

function App() {
  return (
    <div className="App scroll-smooth">
      <BadgeKiller />
      <AdminProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Navbar /><HomePage /><Footer /></>} />
            <Route path="/services" element={<><Navbar /><ServicesPage /><Footer /></>} />
            <Route path="/work" element={<><Navbar /><WorkPage /><Footer /></>} />
            <Route path="/pricing" element={<><Navbar /><PricingPage /><Footer /></>} />
            <Route path="/about" element={<><Navbar /><AboutPage /><Footer /></>} />
            <Route path="/contact" element={<><Navbar /><ContactPage /><Footer /></>} />
            <Route path="/privacy" element={<><Navbar /><PrivacyPolicyPage /><Footer /></>} />
            <Route path="/terms" element={<><Navbar /><TermsPage /><Footer /></>} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/admin/services" element={<ProtectedRoute><AdminServicesPage /></ProtectedRoute>} />
            <Route path="/admin/projects" element={<ProtectedRoute><AdminProjectsPage /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute><AdminTestimonialsPage /></ProtectedRoute>} />
            <Route path="/admin/faqs" element={<ProtectedRoute><AdminFAQsPage /></ProtectedRoute>} />
            <Route path="/admin/pricing" element={<ProtectedRoute><AdminPricingPage /></ProtectedRoute>} />
            <Route path="/admin/about" element={<ProtectedRoute><AdminAboutPage /></ProtectedRoute>} />
            <Route path="/admin/leads" element={<ProtectedRoute><AdminLeadsPage /></ProtectedRoute>} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AdminProvider>
    </div>
  );
}

export default App;
